export const vendors = [
  
  {
    id: 'vendor1',
    name: 'Berry luxe bags',
    logo: "berrylogo.jpeg", // ✅ match actual image
    description: 'for more infor reached out to me on 0743674725',

  },
  {
    id: 'vendor2',
    name: 'samstech',
    logo: "sam logo.jpeg", // ✅ match actual image
    description: 'Affordable tech gadgets for more infor reached out to me on 0764306612',
    
  },
 
];

